export default {
    noWikiExisting: 'Für diese Anwendung existieren keine Hilfeseiten.',
    invalidPage: 'Die aufgerufene Hilfeseite existiert nicht.',
    invalidPageExplanation: 'Die aufgerufene URL ist keiner Hilfeseite zugeordnet, oder es wurde für diese Seite noch kein Inhalt gepflegt.',
    initWikiExplanation: 'Die Homepage und weitere Seiten müssen erst im angebundenen CMS angelegt werden.'
}
